import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import classNames from 'classnames';
import IframeLogin from './iframe_login';
import { NotificationService } from '../../services/notification.service';
import { RegistrationService } from '../registration.service';
import { LoadingService } from '../../services/loading.service';
import { RegistrationStore } from '../registration.store';
import * as _ from 'lodash';

export default class RegistrationStep4 extends Component {
  constructor(props) {
    super(props);
    this.temp_state = RegistrationStore.getState();
    this.registrationService = new RegistrationService();
    this.notificationService = new NotificationService();
    this.loadingService = new LoadingService();
    this.state = {
      isLoading: false,
    };
  }

  async componentDidMount() {
    // Reverting the PRs should be enough to deal with the incompatibility
    // However, here's the code that was before (faa34f388332fba0d3ae337a92f669cda4333235)
    // try {
    //   Android.mobileRegistrationSuccess(this.props.state.username);
    // } catch (err) {
    //   // we're not in android
    //   this.accessAccount()
    // }

    const body = {
      access_token: this.temp_state.signupRespData.patient.jwt_token,
      user_id: this.temp_state.signupRespData.patient.id,
      method: 'registration',
    };

    let mobileDetected = false;

    if (
      typeof window.Android !== 'undefined' &&
      _.isFunction(window.Android.mobileRegistrationSuccess)
    ) {
      /* eslint @typescript-eslint/camelcase: 0 */
      window.Android.mobileRegistrationSuccess(JSON.stringify(body));
      mobileDetected = true;
    }

    if (
      _.isFunction(
        _.get(
          window,
          'webkit.messageHandlers.mobileRegistrationSuccess.postMessage',
          null
        )
      )
    ) {
      /* eslint @typescript-eslint/camelcase: 0 */
      window.webkit.messageHandlers.mobileRegistrationSuccess.postMessage(
        JSON.stringify(body)
      );
      mobileDetected = true;
    }

    if (!mobileDetected) {
      this.accessAccount();
    }
  }

  accessAccount() {
    this.setState({ isLoading: true });

    var cookies_form = document.getElementById('cookies_form');
    cookies_form.submit();

    // @TODO: hacky way of redirect after submit returns 200. Consider refactoring, since cookies_form.submit() doesn't
    // give us a Promise
    setTimeout(() => {
      window.location.href = '/?account_activated=true';
    }, 5000);

    // @TODO: Returns 404 :/
    //
    // this.registrationService.login(this.props.state.signupRespData)
    //   .then((resp) => {
    //     console.log(resp);
    //     if (resp.status == 200) {
    //       window.location.href = '/dashboard';
    //     }
    //     else {
    //       this.notificationService.error('An error occurred while going to the dashboard');
    //     }
    //   });
  }

  render() {
    return (
      <div className="row h-100">
        <div className="col col-12 content-block text-center">
          <div
            hidden={!this.state.isLoading}
            style={{ position: 'relative', top: '50%' }}
          >
            <CircularProgress />
            <div hidden={true}>
              <IframeLogin />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./registration-react/components/registration-step4.js